import Head from 'next/head'
import Image from "next/legacy/image";
import styles from "../styles/pages/Restaurant.module.scss"
import Link from 'next/link'
import Slider from "react-slick";
import Restaurantgallery from '../components/Restaurantgallery/Restaurantgallery'
import DiningPageForm from '../components/Contactusform/DiningPageForm';
import Accordion from '../components/Accordion/Accordion';
import { useState } from 'react';
import AboutGallery from '../components/AboutGallery/AboutGallery';
import FAQs from '../components/Faqs';
import WeddingPageForm from '../components/Contactusform/WeddingPageForm';

export default function Wedding() {

    const galleryImages = [
        {
            bgImage: "/images/events/wedding-gallery/wedding-img1.jpg",
            altTest: "Wedding image 1",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img2.jpg",
            altTest: "Wedding image 2",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img3.jpg",
            altTest: "Wedding image 3",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img4.jpg",
            altTest: "Wedding image 4",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img5.jpg",
            altTest: "Wedding image 5",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img6.jpg",
            altTest: "Wedding image 6",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img7.jpg",
            altTest: "Wedding image 7",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img8.jpg",
            altTest: "Wedding image 8",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img9.jpg",
            altTest: "Wedding image 9",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img10.jpg",
            altTest: "Wedding image 10",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img11.jpg",
            altTest: "Wedding image 11",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img12.jpg",
            altTest: "Wedding image 12",
        },
        {
            bgImage: "/images/events/wedding-gallery/wedding-img13.jpg",
            altTest: "Wedding image 13",
        },
    ];

    const amenities = [{
        title: "Decoration",
        description: "Enchanting settings that captivate hearts, with beautiful themes and stunning floral arrangements.",
        hyperLink: "/",
        icon: "/icons/events/decoration.svg",
    },
    {
        title: "Accommodation",
        description: "Luxurious rooms and suites for a comfortable and memorable stay.",
        hyperLink: "/",
        icon: "/icons/events/accomodation.svg",
    },
    {
        title: "Ample Parking",
        description: "Convenient parking with plenty of space for all your guests.",
        hyperLink: "/",
        icon: "/icons/events/parking.svg",
    },
    {
        title: "Catering",
        description: "Delicious gourmet cuisine crafted to impress and delight every palate.",
        hyperLink: "/",
        icon: "/icons/events/catering.svg",
    },
    {
        title: "Entertainment",
        description: "Interactive games and engaging activities for all guests to enjoy.",
        hyperLink: "/",
        icon: "/icons/events/entertainment.svg",
    },
    {
        title: "Adventure",
        description: "Exciting activities and experiences to thrill and entertain your guests.",
        hyperLink: "/",
        icon: "/icons/events/adventure.svg",
    },
    {
        title: "Venue",
        description: "Beautiful locations with breathtaking views, perfect for your special celebration.",
        hyperLink: "/",
        icon: "/icons/events/venue.svg",
    },
    {
        title: "Video & Photography",
        description: "Capture precious moments with professional videography and photography services.",
        hyperLink: "/",
        icon: "/icons/events/photography.svg",
    },
    ];

    const faqsData = [
        {
            id: 1,
            accordionQuestion: "Why choose The Twin Towers Hotel for our destination wedding in Shimla?",
            accordionAnswer: "The Twin Towers Hotel provides luxurious accommodations, stunning venues, and exceptional services, making it perfect for your dream wedding in Himachal Pradesh."
        },
        {
            id: 2,
            accordionQuestion: "What amenities does The Twin Towers Hotel offer for a destination wedding?",
            accordionAnswer: "The Twin Towers Hotel offers a beautiful banquet hall, exquisite dining, luxurious accommodations, and professional event-planning services for your dream wedding in Himachal Pradesh."
        },
        {
            id: 3,
            accordionQuestion: "How far in advance should we book our destination wedding in Shimla?",
            accordionAnswer: "It's recommended to book your destination wedding in Shimla at least 6-12 months in advance to secure your preferred dates and venues."
        },
        {
            id: 4,
            accordionQuestion: "What is included in a destination wedding package at The Twin Towers Hotel?",
            accordionAnswer: "Our destination wedding packages at The Twin Towers Hotel include venue rental, catering, decoration, accommodation, and event coordination, ensuring a seamless and unforgettable celebration."
        },
        {
            id: 5,
            accordionQuestion: "Is ample parking available for guests attending a destination wedding in Shimla?",
            accordionAnswer: "Yes, The Twin Towers Hotel provides ample parking space to accommodate all your guests comfortably."
        }
    ];

    const scrollToSection = (redirectedSection) => {
        const section = document.getElementById(redirectedSection);
        if (section) {
            section.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };

    const handleScrollClick = (section) => {
        return () => scrollToSection(section);
    };

    return (
        <>
            <Head>
                <title>Best Banquet Hall in Shimla For dream destination wedding</title>
                <meta name="description" content="Plan your dream destination wedding at the banquet hall in The Twin Towers Hotel, Shimla. Explore our luxurious venues and scenic locations for a memorable celebration. Book now!" />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/banquet-halls-in-shimla" />
                <meta name="keywords" content="Banquet Halls in Shimla Dream Wedding Destination Wedding in Shimla Wedding Destination celebration banquet banquet halls for weddings venues for weddings near me"></meta>
            </Head>
            {/* <Slider {...settings} className="banner_slider">
                {bannerImages.map((item, index) => ( */}
            <section >
                <div
                    className={styles.wedding_meeting_banner}
                    style={{
                        backgroundImage: `url(/images/events/ananta-meeting-banner-new.png)`,
                    }}
                >
                    <div className={styles.banner_text}>
                        <div className="container">
                            <div className={styles.banner_btn}>
                                <Image src='/icons/down-arrow.svg' height={40} width={40} alt='Down Icon' onClick={handleScrollClick('homeSection')}></Image>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ))}
            </Slider> */}

            <section className={styles.best_venue_sec} id='homeSection'>
                <div className='container'>
                    <div className={`${styles.best_venue_sec_main} common_title`}>
                        <h1>Celebrate Your Dream Destination Wedding in Shimla</h1>
                        <p>Experience your dream wedding at The Twin Towers Hotel, where elegance meets breathtaking landscapes. Located in Shimla, amidst the serene beauty of Himachal Pradesh, we offer the best destination wedding experience. Imagine exchanging vows in the picturesque setting of Kufri, surrounded by mountains and pine forests. Our dedicated team ensures every detail of your special day is perfect, from decor to cuisine, creating timeless memories for you and your guests. </p>
                    </div>
                </div>
            </section>

            <section className={`${styles.restaurant} common_padding`}>
                <div className='container'>
                    <div className={`${styles.restaurant_top} row`}>
                        <div className={`${styles.res_top_left} col-md-6 col-sm-12 common_title`}>
                            <div className={`${styles.center_div} col-md-10`}>
                                <h2>A Venue That Echoes Your Love</h2>
                                <p>Host your dream wedding at our exquisite banquet hall, offering the best destination wedding experience in Shimla. Our venue combines elegance with scenic views of Himachal Pradesh, ensuring a memorable celebration. Whether you envision a grand affair or an intimate gathering, our dedicated team will tailor every detail to perfection. </p>
                                <Link href="#book_your_event" className="common_btn m-0">Enquire Now</Link>
                            </div>

                        </div>
                        <div className={`${styles.res_top_right} col-md-6 col-sm-12`}>
                            <img src="/images/events/wedding-img1.png" alt='Restaurant Image' />
                        </div>
                    </div>
                    <div className={`${styles.restaurant_top_two} row`}>
                        <div className={`${styles.res_top_left_two} col-md-6 col-sm-12`}>
                            <img src="/images/events/wedding-img2.png" alt='Restaurant Image' />
                        </div>
                        <div className={`${styles.res_top_right_two} col-md-6 col-sm-12 common_title justify-content-end`}>
                            <div className={`${styles.center_div} col-md-10`}>
                                <h2>Exceptional Dining, Memorable Moments</h2>
                                <p>Experience culinary excellence in our dining area, the perfect complement to your dream wedding celebration in Shimla. Our talented chefs craft dishes that delight the senses, ensuring every meal is a highlight of your special day. Whether it's a grand wedding feast or an intimate dinner, our dining area offers an exceptional blend of taste and ambiance for our cherished guests.</p>
                                <Link href="#book_your_event" className="common_btn m-0">Enquire Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className={`${styles.wedding_amenities}`}>
                <div className='container'>
                    <div className='common_title'>
                        <h2 className='text-center'>Services We Provide</h2>
                        <div className={`${styles.amenities_main} row`}>
                            {amenities.map((item, index) => (
                                <div key={index} className="col-lg-3 col-md-6">
                                    <div className={styles.amenities}>
                                        <Image src={item.icon} width={38} height={38} className={styles} alt="Highlights icon" />
                                        <h3>{item.title}</h3>
                                        <p className='text-center'>{item.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <section className='common_padding'>
                <AboutGallery galleryImages={galleryImages} galleryHeading={'Successful Events'} />
            </section>

            <section style={{ backgroundColor: '#F5F5F5', paddingBottom: '0' }} id='book_your_event'>
                <div className='container'>
                    <WeddingPageForm formId={'banquetBookingForm'} formClass={'banquet-form'} />
                </div>
            </section>

            <div className='common_padding'>
                <div className="container">
                    <h2 className="hotel_page_hotel_haeding mb-2 text-center">FAQs</h2>
                    <FAQs faqsData={faqsData} />
                </div>
            </div>
        </>
    )
}
